<script setup lang="ts">
import { computed } from 'vue';
import Banner from '@/components/layout/Banner.vue';
import { getLabel, getLocale } from '@/utils/data-display-utils';
import { Community } from '@/store/communityStore';
import { Locales } from '@/store/language.interface';

// PROPS
const props = defineProps<{
  community: Community;
  languageEnabled?: Locales[];
}>();

// COMPUTED
const appLocale = computed(() => getLocale(props.languageEnabled));
const isSubjectToLaw96 = computed(() => {
  return props.community.options.loi96 ?? false;
});
</script>

<template>
  <Banner :message="getLabel('banner.loi96', props.languageEnabled)" v-if="appLocale !== 'fr' && isSubjectToLaw96" />
</template>

<style scoped lang="scss"></style>
